// src/components/FeedbackCard.jsx
import React from "react";
import EvaluationOutcome from "./EvaluationOutcome";

export default function FeedbackCard({
  feedback,
  coach,
  rubricScore,
  passed,
  attempt,
  attemptsAllowed,
  allowRepeat,
  statusCopy,
  displayFrame,
}) {
  if (!feedback) return null;

  const tone = coach?.tone || "soft";
  const resolvedScore = Number.isFinite(Number(feedback?.score))
    ? Number(feedback.score)
    : Number.isFinite(Number(rubricScore))
    ? Number(rubricScore)
    : null;
  const resolvedPassMark = Number.isFinite(Number(feedback?.pass_score))
    ? Number(feedback.pass_score)
    : null;
  const showAttemptSummary =
    Number.isFinite(Number(attempt)) &&
    Number.isFinite(Number(attemptsAllowed)) &&
    Number(attemptsAllowed) > 1;
  const scoreLabel = String(
    displayFrame?.score_label || feedback?.display_frame?.score_label || "Score"
  ).trim() || "Score";
  const feedbackTimestamp = feedback?.feedback_generated_at;
  const formattedFeedbackTimestamp = feedbackTimestamp
    ? (() => {
        const parts = new Intl.DateTimeFormat("en-US", {
          timeZone: "Asia/Karachi", day: "numeric", month: "long", year: "numeric",
          hour: "numeric", minute: "2-digit", hour12: true,
        }).formatToParts(new Date(feedbackTimestamp));
        const get = (type) => parts.find((part) => part.type === type)?.value || "";
        return `${get("day")} ${get("month")} ${get("year")} · ${get("hour").replace(/^0/, "")}:${get("minute")} ${get("dayPeriod").toUpperCase()} PKT`;
      })()
    : null;

  return (
    <>
      <section
        id="feedback-card"
        className={`lp-box fb-card ${tone === "strict" ? "fb-tone--strict" : "fb-tone--soft"}`}
      >
        <header className="fb-head">
          <div className="fb-status-copy">
            <div className="fb-status-heading">Evaluation summary</div>
            {formattedFeedbackTimestamp ? <div>{formattedFeedbackTimestamp}</div> : null}
            <div className="fb-status-subline">Use this to improve your next draft.</div>
          </div>

        <div className="fb-pills" aria-label="Feedback summary">
          {resolvedScore != null && (
            <div className="fb-pill">
              {scoreLabel}: <b>{Math.round(resolvedScore)}</b> / 100
            </div>
          )}
          {resolvedPassMark != null && (
            <div className="fb-pill">
              Pass mark: <b>{Math.round(resolvedPassMark)}</b>
            </div>
          )}
          {showAttemptSummary && (
            <div className="fb-pill">
              Attempt <b>{attempt}</b> of <b>{attemptsAllowed}</b>
            </div>
          )}
        </div>
        </header>
      </section>
      <EvaluationOutcome
        score={resolvedScore}
        passMark={resolvedPassMark}
        attemptNumber={attempt}
        maxAttempts={attemptsAllowed}
        passed={passed}
      />
    </>
  );
}
